import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import translations from '@shopify/polaris/locales/es.json';
import {
  AppProvider, Card, Page, 
  Button, 
  DisplayText, Tabs, ResourceList, ResourceItem, 
  TextStyle, Tooltip, Stack, Icon 
} from '@shopify/polaris';

import TransferGeneralInfo from "@presentational/transfer/components/TransferGeneralInfo";
import TransactionsHistory from '@container/sale_report/components/SaleReportTransactionsHistory';
import LogsList from "@presentational/transfer/components/LogsList";

import { transferShape } from 'utils/shapeProps';

const propTypes = {
  transfer: transferShape.isRequired,
  transferURLBase: PropTypes.string.isRequired,
  saleReportURLBase: PropTypes.string.isRequired,
  variantLogsURLBase: PropTypes.string.isRequired,
}

const defaultProps = {

}

const tabs = [
  { id: 'information', content: "Información General", accessibilityLabel: 'Admin', },
  { id: 'logs', content: "Logs", accessibilityLabel: 'Admin', },
  { id: 'sales', content: "Detalle de Ventas", accessibilityLabel: 'sales', },
];

const TransferLegacyInformation = (props) => {
  const [tabSelected, setTabSelected] = useState(0);
  const transfer = props.transfer;

  const handleTabChange = useCallback( (selectedTabIndex) => setTabSelected(selectedTabIndex),  [], );

  return (
    <AppProvider i18n={translations}>
      <Page
        title= { `${ I18n.t("activerecord.models.transfer.one") } ${transfer.name} - Información Legacy` }
        breadcrumbs= {[{content: I18n.t("actions.back"), url: `/transfers/${transfer.id}`}]}
        fullWidth
      >
        <Tabs
          tabs={tabs}
          selected={ tabSelected }
          onSelect={ handleTabChange }
        />

        <div>
          { tabSelected === 0 && <TransferGeneralInfo transfer={ transfer }  /> }

          { tabSelected === 1 && <LogsList transferItems={ transfer.products_transfers} symbol= { transfer.currency_symbol} /> }

          { tabSelected === 2 &&
            <Card>
              <TransactionsHistory
                isSeller={ false }
                displaySaleReportColumn
                transferURLBase={ props.transferURLBase }
                saleReportURLBase={ props.saleReportURLBase }
                transactions={ transfer.total_invoice_by_source.transaction_history }
                transactionTotalsMoney={ [transfer.total_invoice_by_source.grand_total] }
                variantLogsURLBase={ props.variantLogsURLBase }
              />
            </Card>
          }
        </div>
      </Page>
    </AppProvider>
  )
};

TransferLegacyInformation.propTypes = propTypes;
TransferLegacyInformation.defaultProps = defaultProps;

export default TransferLegacyInformation;